import { render, staticRenderFns } from "./CreateReceiptType.vue?vue&type=template&id=f1ad2cf2"
import script from "./CreateReceiptType.vue?vue&type=script&lang=js"
export * from "./CreateReceiptType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports